// 引入课程组件
import CourseComponent from '../../components/courseComponent/CourseComponent.vue'
// 引入项目组件
import ProjectComponent from '../../components/projectComponent/ProjectComponent.vue'

export default {
    data() {
        return {
            //是否出现加载中符号
            loading:true,
            all: 1, //总页数
            cur: 1,//当前页码
            //选择打印证书按钮
            certificateButton: true,
            //选择多个证书打印数组
            certificateArr: [],
            //已完成的证书
            okCertificate:[],
            orderId: '',
            goodId: '',
            shopId: '',
            isNeedYear: false,
            infoRemind: '请确认信息无误',
            finishedClassNum: 0,
            studyingClassNum: 0,
            certificateFinished: 0,
            // certificateGenerate: 0,
            certificateNot: 0,
            annual: '',
            headImg: require('../../assets/images/avatar.jpg'),
            users: {},
            //全部课程
            classList: [],
            //在读课程
            inschoolclass:[],
            //已完成课程
            accomplishclass:[],
            // 未完成证书
            unfinishedcredential:[],
            // 已完成证书
            accomplishcredential:[],
            // 已生成证书
            certificateList: [],
            inputModel: [],
            message: '',
            // 课程类型筛选
            checked1:false,
            checked2:false,
            // 认定类型筛选
            checked3:false,
            checked4:false,
            // 年度筛选
            options: [{
                value: '全部',
                label: '全部'
              } ],
            value: '全部',
            cosl:1,//点击课程导航标记
            cosl0:1,//点击证书导航标记
			is_project:this.$store.state.store.is_project,//判断导航栏显示
			//更换风格弹出框
			currentDialog:false,
			// 个人中心风格
			styleIndex: 0,
			// 我的风格列表
			styleList:[
				require('@/assets/images/personalcenter.png'),
				require('@/assets/images/personalcenter1.png'),
				require('@/assets/images/personalcenter2.png'),
			],
        }
    },
    methods: {
		//更换风格
		currentStyleButton(){
			this.$post('users/style_current',{
				my_style:this.styleIndex,
				token:this.$store.state.id
			}).then(res=>{
				this.$store.state.my_style = this.styleIndex
				if(this.styleIndex == 2 ){
					this.$router.push('/personalcenter2')
				}
				if(this.styleIndex == 1 ){
					this.$router.push('/personalcenter1')
				}
			})
			
		},
		// 更换风格弹出框
		currentButton(){
			this.currentDialog = true
		},
		// 更换风格
		changeStyle(index) {
		    this.styleIndex = index
		},
        // //选择多选框改变确认打印按钮
        // isPrint: function () {
        //     if (this.certificateArr.length > 0) {
        //         document.querySelector('#confirm-print-btn').removeAttribute('disabled');
        //     } else {
        //         document.querySelector('#confirm-print-btn').setAttribute('disabled', 'disabled');
        //     }
        // },
        //选择证书打印
        // chooseCertificate: function () {
        //     if (this.certificateButton == true) {
        //         this.certificateButton = false;
        //         this.certificateArr = [];
        //     } else {
        //         this.certificateButton = true;
        //         document.querySelector('#confirm-print-btn').setAttribute('disabled', 'disabled');
        //     }
        // },

        //证书详情
        // goCertificate: function (pay_date, goodId, year) {
        //     let address = this.$router.resolve({
        //         path: '/studyingcertificate',
        //         query: {
        //             pay_date: pay_date,
        //             goodId: goodId,
        //             year: year
        //         }
        //     });
        //     window.open(address.href, '_blank');
        // },
        // downloadBook:function(item){
        //     // // console.log(1111111111111);
        //     this.goCertificate(item.pay_date,item.ids,item.cer_year)
        // },
        //跳转首页
        goIndex: function () {
            this.$router.push({
                path: '/'
            })
        },
        //跳转课程详情
        classDetails: function (id,is_project) {
            this.$toClass(id,is_project);
        },
        //获取个人信息
        getusers: function () {
            this.$post('users/profile', { token: this.$store.state.id }).then(res => {
                this.users = res.data.result;
                // this.users.name ? document.querySelector('#name').setAttribute('disabled', 'disabled') : this.users.name;
                // this.users.company ? document.querySelector('#company').setAttribute('disabled', 'disabled') : this.users.company;
                //判断信息是否完成，如若一项不完成都弹出下面的提示
                if (this.users.name == null || this.users.company == null || this.users.name == '' || this.users.company == '') {
                    // this.message = '请完善个人信息，如不需要开具学时证明，则可以不填写。';
                    // let model = document.querySelector('#modal-tip-addname');
                    // UIkit.modal(model).show();
                } else {
                    // let model = document.querySelector('#modal-tip-addname');
                    // UIkit.modal(model).show();
                }
            })
        },
        //跳转编辑个人信息页面
        editInfo: function () {
            this.$router.push({
                path: '/editinfo'
            })
        },
        //跳转更改密码页面
        changepassword: function () {
            this.$router.push({
                path: '/changepassword'
            })
        },
        updateKeyDown: function () {

        },
        // //确认打印证书按钮的判断和给出提示
        // confirmPrint: function () {
        //     //置空年度
        //     this.annual='';
        //     //存储课程自带的年度
        //     let cer_years = [];
        //     //专业课数组
        //     let proClass=[];
        //     //选修课数组
        //     let avoClass=[];
        //     // // console.log(this.certificateArr);
        //     for (let val of this.certificateArr) {
        //         if(val.attr=='专业课'){
        //             proClass.push(val);
        //         }
        //         if(val.attr=='选修课'){
        //             avoClass.push(val);
        //         }
        //         if (val.cer_year && val.cer_year != null && val.cer_year != '') {
        //             cer_years.push(Number.parseFloat(val.cer_year.substr(0, 4)));
        //         }else if(val.is_first&&val.is_first!=null&&val.is_first!=''){
        //             cer_years.push(Number.parseFloat(val.is_first));
        //         }
        //     }
        //     if(proClass.length>0&&avoClass.length>0){
        //         UIkit.modal(document.querySelector('#modal-no-attr')).show();
        //         return;
        //     }
        //     if (cer_years.length == 0) {
        //         let str = '请填写';
        //         this.isNeedYear = true;
        //         this.users.name == '' ? str += '姓名，' : str;
        //         this.users.idcard == '' ? str += '身份证号，' : str;
        //         this.users.company == '' ? str += '单位名称，' : str;
        //         this.annual == ''||Number.parseFloat(this.annual)<2018||this.annual.toString().length>4 ? str += '申报年度，申报年度格式为：例子：2018，且不能是2018年之前的，' : str;
        //         str = str.substr(0, str.length - 1);
        //         this.infoRemind = str;
        //         UIkit.modal(document.querySelector('#modal-personalcenter')).show();
        //     } else if (cer_years.length == 1) {
        //         this.tipModalOne(cer_years);
        //     } else if (cer_years.length > 1) {
        //         if (!this.isSame(cer_years)) {
        //             UIkit.modal(document.querySelector('#modal-same-year')).show();
        //         } else {
        //             this.tipModalOne(cer_years)
        //         }
        //     }
        // },
        //判断一个数组里面的东西是否都是一样的
        // isSame: function (arr) {
        //     for (let val of arr) {
        //         if (val !== arr[0]) {
        //             return false;
        //         }
        //     }
        //     return true;
        // },
        //提示模板1
        // tipModalOne: function (cer_years) {
        //     this.isNeedYear = false;
        //     if (!this.users.name || !this.users.idcard || !this.users.company) {
        //         let str = '请填写';
        //         this.isNeedYear = false;
        //         this.users.name == '' ? str += '姓名，' : str;
        //         this.users.idcard == '' ? str += '身份证号，' : str;
        //         this.users.company == '' ? str += '单位名称，' : str;
        //         this.certificateArr.length > 1 ? str += '本次证明中包含【仅适用于' + cer_years[0] + '】的课程，其余课程无法设置为其他年度，' : str;
        //         str = str.substr(0, str.length - 1);
        //         this.infoRemind = str;
        //     } else {
        //         this.infoRemind = '请确认信息无误，'
        //         this.certificateArr.length > 1 ? this.infoRemind += '本次证明中包含【仅适用于' + cer_years[0] + '】的课程，其余课程无法设置为其他年度，' : this.infoRemind;
        //         this.infoRemind = this.infoRemind.substr(0, this.infoRemind.length - 1);
        //     }
        //     UIkit.modal(document.querySelector('#modal-personalcenter')).show();
        // },
        //证书保存
        // saveCertificate: function () {
        //     //存储课程自带的年度
        //     let cer_years = [];
        //     //用户id
        //     let owner_id = this.$store.state.userId;
        //     //订单项id
        //     let purchased_ids = [];
        //     //订单项的订单时间数组
        //     let order_times=[];
        //     //最小的时间戳
        //     let small_times=Infinity;
        //     //最小时间段
        //     let samll_Dates='';
        //     for (let val of this.certificateArr) {
        //         purchased_ids.push(Number.parseFloat(val.id))
        //         order_times.push(val.created_at);
        //         if(new Date((val.created_at).replace(/-/g, "/")).getTime()<small_times){
        //             small_times=new Date((val.created_at).replace(/-/g, "/")).getTime();
        //             samll_Dates=val.created_at;
        //         }
        //         if (val.cer_year && val.cer_year != null && val.cer_year != '') {
        //             cer_years.push(Number.parseFloat(val.cer_year.substr(0, 4)));
        //         }else if(val.is_first&&val.is_first!=null&&val.is_first!=''){
        //             cer_years.push(Number.parseFloat(val.is_first));
        //         }
        //     }
        //     if (cer_years.length == 0) {
        //         let index=0;
        //             if (this.users.name && this.users.idcard && this.users.company && Number.parseFloat(this.annual) > 2017 && this.annual.length == 4) {
        //                 this.$post('cers/create',{token:this.$store.state.id,purchased_id:JSON.stringify(purchased_ids),owner_id:owner_id,cer_year:Number.parseFloat(this.annual),pay_date:samll_Dates}).then(res=>{
        //                     UIkit.modal(document.querySelector('#modal-personalcenter')).hide();
        //                     this.goCertificate(samll_Dates, JSON.stringify(purchased_ids), Number.parseFloat(this.annual));
        //                     for(let orderGoodId of purchased_ids){           
        //                         this.$post('purchased/updateCerYear',{token:this.$store.state.id,is_first:this.annual,id:orderGoodId,cer_year:1}).then(res=>{
        //                                 ++index;
        //                                 if(index==purchased_ids.length){
        //                                     setTimeout(()=>{
        //                                         this.certificateList=[];
        //                                         this.classList=[];
        //                                         this.certificateArr=[];
        //                                         this.certificateButton=true;
        //                                         this.getMyCertificate();
        //                                         this.alreadyCreated()
        //                                     },1000)
        //                                 }
        //                         }) 
        //                     }
        //                 })
                        
        //             } else {
        //                 let str = '请填写';
        //                 this.users.name == '' ? str += '姓名，' : str;
        //                 this.users.idcard == '' ? str += '身份证号，' : str;
        //                 this.users.company == '' ? str += '单位名称，' : str;
        //                 this.annual == ''||Number.parseFloat(this.annual)<2018 ? str += '申报年度，申报年度格式为：例子：2018，且不能是2018年之前的，' : str;
        //                 str = str.substr(0, str.length - 1);
        //                 this.infoRemind = str;
        //             }
        //     } else if (cer_years.length >= 1) {
        //             this.annual=Number.parseFloat(cer_years[0].toString().substr(0,4));
        //             let index=0;
        //             if (this.users.name && this.users.idcard && this.users.company) {
        //                 this.$post('cers/create',{token:this.$store.state.id,purchased_id:JSON.stringify(purchased_ids),owner_id:owner_id,cer_year:Number.parseFloat(this.annual),pay_date:samll_Dates}).then(res=>{
        //                     UIkit.modal(document.querySelector('#modal-personalcenter')).hide();
        //                     this.goCertificate(samll_Dates, JSON.stringify(purchased_ids), Number.parseFloat(this.annual));
        //                     for(let orderGoodId of purchased_ids){
        //                         this.$post('purchased/updateCerYear',{token:this.$store.state.id,is_first:this.annual,id:orderGoodId,cer_year:1}).then(res=>{
        //                             ++index;
        //                             if(index==purchased_ids.length){
        //                                 setTimeout(()=>{
        //                                     this.certificateList=[];
        //                                     this.classList=[];
        //                                     this.certificateArr=[];
        //                                     this.certificateButton=true;
        //                                     this.getMyCertificate();
        //                                     this.alreadyCreated()
        //                                 },1000)
        //                             }
        //                         })
        //                     }
        //                 })
                        
        //             } else {
        //                 let str = '请填写';
        //                 this.users.name == '' ? str += '姓名，' : str;
        //                 this.users.idcard == '' ? str += '身份证号，' : str;
        //                 this.users.company == '' ? str += '单位名称，' : str;
        //                 this.certificateArr.length > 1 ? str += '本次证明中包含【仅适用于' + cer_years[0].substr(0,4) + '】的课程，其余课程无法设置为其他年度，' : str;
        //                 str = str.substr(0, str.length - 1);
        //                 this.infoRemind = str;
        //             }
        //     }
        // },
        //获取已经生成的证书
        // alreadyCreated:function(){
        //     this.okCertificate=[];
        //     this.$post('cers/search',{
        //         token:this.$store.state.id,
        //         offset:0,length:999
        //     }).then(res=>{
        //         for(let val of res.data.result.data){
        //             let obj={};
        //             let me=this;
        //             obj.cer_year=val.cer_year;
        //             obj.pay_date=val.pay_date;
        //             obj.ids=val.purchased_id;
        //             obj.name=[];
        //             for(let id of JSON.parse(val.purchased_id)){
        //                 (function(id){
        //                     me.$post('purchased/get',{token:me.$store.state.id,id:id}).then(res=>{
        //                         // console.log('这是什么',res.data.result);
        //                         obj.name.push(res.data.result.product_name);
        //                     })
        //                 })(id)
        //             }
        //             this.okCertificate.push(obj);
        //         }
        //     })
        // },
      
           

        // 标记打开页面
        // cosl1(res){
        //     this.cosl=res
        //     this.init()
        // },
        // // 证书
        // cosl2(res){
        //     this.cosl0=res
        //     this.init()
        // },
        // init(){
        //     this.checked1=false
        //     this.checked2=false
        //     this.checked3=false
        //     this.checked4=false
        //     this.value='全部'
        //     this.screen1()
        // },
        // 获取筛选时间数组
        // getdate(){
        //     let date=new Date;
        //     let arr ={}
        //     let year=date.getFullYear(); 
        //     for(let i=year;i>=2018;i--){
        //          arr = {
        //             value: i,
        //             label: i
        //           } 
        //         this.options.push(arr)
        //     }
        // },
        // 筛选
        // screen1(){
        //     let data
        //     let product_attr
        //     let products_cer_year
        //     let products_is_auth
        //     let  url = 'purchased/search_pay_all'
        //     if(this.checked1){
        //        product_attr = '专业课'
        //        this.checked2 = false
        //     }else if(this.checked2){
        //        product_attr = '选修课'
        //        this.checked1 = false
        //     }else{
        //         product_attr=''
        //     }
        //     if(this.checked3){
        //         products_is_auth = 1 //认定
        //         this.checked4 = false
        //      }else if(this.checked4){
        //         products_is_auth = 0 //非认定
        //         this.checked3 = false
        //      }else{
        //         products_is_auth=''
        //      }
        //     if(this.value == '全部'){
        //         products_cer_year = ''
        //     }else{
        //         products_cer_year = this.value
        //     }
        //     data = {
        //         token: this.$store.state.id, 
        //         offset: 0, 
        //         length: '9999' ,
        //         product_attr:product_attr,
        //         products_cer_year:products_cer_year,
        //         products_is_auth:products_is_auth
        //     }
        //     if(this.cosl == 1){//获取全部课程
        //         this.get(url,data)
        //     }else if(this.cosl == 2){//获取在读课程
        //         url = 'purchased/search_pay_all_type_two'
        //         data.progress_lt = 1
        //         data.score_lt = 60
        //         this.get(url,data)
        //     }else if(this.cosl == 3){//获取已完成课程
        //         data.progress = 1
        //         data.score_ge = 60
        //         this.get(url,data)
        //     }else if(this.cosl == 4){//获取证书课程
        //         if(this.cosl0 == 1){//未完成证书
        //             url = 'purchased/search_pay_all_type_two'
        //             data.progress_lt = 1
        //             data.score_lt = 60
        //             this.get(url,data)
        //         }else if(this.cosl0 == 2){//已完成证书
        //             data.progress = 1
        //             data.score_ge = 60
        //             data.purchased_cer_year = 0
        //             this.get(url,data)
        //         }else if(this.cosl0 == 3){//已生成证书
        //             this.alreadyCreated();
        //         }
        //     } 
        // },
        // screen2(){
        //     if(this.checked2){
        //         this.checked1 = false;
        //     }
        //     if(this.checked4){
        //         this.checked3 = false;
        //     }
        //     this.screen1();
        // },
        // //获取数据
        // get(url,data){
        //     //一点击获取数据就进入加载中
        //     // this.loading=true;
        //     // v-loading="false"
        //     // let me = this;
        //     // v-loading="loading"
        //     this.loading = true
        //     this.$post(url, data).then(res => {
        //         if(this.cosl == 1){
        //             this.classList = res.data.result.data;
        //             this.loading = false;
        //         }else if(this.cosl == 2){
        //             this.inschoolclass = res.data.result.data;
        //             this.loading = false;
        //         }else if(this.cosl == 3){
        //             this.accomplishclass = res.data.result.data;
        //             this.loading = false;
        //         }else if(this.cosl == 4){
        //             if(this.cosl0 == 1){
        //                 this.inschoolclass = res.data.result.data;
        //                 this.loading = false;
        //             }else if(this.cosl0 == 2){
        //                 this.accomplishcredential = res.data.result.data;
        //                 this.loading = false;
        //             }else if(this.cosl0 == 3){
        //                 this.loading = false;
        //             }
                    
        //         }
        //     })
        // },
        //验证时店主后跳转到店铺管理
        toStoreManage(){
            if(String(this.$store.state.shopId)!='undefined'&&String(this.$store.state.shopId)!='null'&&String(this.$store.state.shopId)!=''){
                let address=this.$router.resolve({
                    path:'/coursestoremanagement'
                });
                //新页面打开店铺管理
                window.open(address.href,'_blank');
            }
        }
      
    },
    components: {
        CourseComponent,
        ProjectComponent
    },
    created: function () {
        this.getusers();//获取个人信息
        // this.alreadyCreated();//获取已生成证书
        // this.getdate();//获取筛选时间数组
        // this.screen1()//获取全部课程数据
        // // console.log(this.is_project)
        
  
    },
    mounted: function () {
        document.title = '个人中心';
        UIkit.util.on('#certificate-switch', 'show', function () {
        });
    }
}




